import React from "react"
import {FieldViewProps} from "../../render/view";

export default function FieldProto_View(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    return (
        <div className="ui5-txt-default">{props.field.getDisplayValue(value)}</div>
    )

}